const PAGE_SIZE = 20;

export const getNextPageParam = (
  lastPage: { meta?: { pagination?: { total?: number; nextOffset?: number } } },
  _allPages: unknown,
  lastPageParam: number,
) => {
  const { total = 0, nextOffset } = lastPage.meta?.pagination ?? {};

  // Endpoints where one item can cover several source rows report where the
  // next page starts, because offset + PAGE_SIZE no longer lines up with it.
  const next = nextOffset ?? lastPageParam + PAGE_SIZE;

  // The strict increase guards against looping on an offset that never moves.
  return next < total && next > lastPageParam ? next : undefined;
};

export const getPaginationInput = (pageParam: number) => ({
  limit: PAGE_SIZE,
  offset: pageParam,
});

export const infinitePaginationOptions = {
  input: getPaginationInput,
  initialPageParam: 0,
  getNextPageParam,
};
